/* 🤖 this file was generated by svg-to-ts */
export const DfIconClockSquare16: {
  name: 'clock-square-16';
  data: string;
} = {
  name: 'clock-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 1 .117.007A1 1 0 0 1 9 6v1.596l1.109 1.148.081.095a1 1 0 0 1-1.52 1.294L7.297 8.711a.99.99 0 0 1-.098-.112l-.008-.01a.92.92 0 0 1-.105-.184l-.014-.033a.85.85 0 0 1-.026-.074l-.013-.041a.818.818 0 0 1-.023-.115.88.88 0 0 1-.007-.074L7 8.025V6l.007-.117A1 1 0 0 1 8 5z"/></svg>`
};
